<template>
  <div class="home" :style="'background-position:0 '+height+'; background-size:100% auto;'">

    <el-carousel
      trigger="click"
      style="width: 100%;max-height:600px"
      :height="height"
      arrow="never"
      ref="nop"
    >
    <div  @touchstart="start($event)" @touchmove="move($event)">
      <el-carousel-item v-for="item in carousolList" :key="item.pic" >
        <div style="width:100%;height:100%;display:flex;justify-content: center;background-color:#000;cursor: pointer;">
        <el-image
          :src="`${width > 500 ? item.pic : item.m_pic? item.m_pic : item.pic}`"
          alt=""
          class="home_carousel"
          fit="cover"
          @click="gotoDetail(item.url)"
        >
          <el-image slot="placeholder" :src="require('../assets/test.jpg')"  v-loading="load"  class="image-slot">
            
          </el-image>
        </el-image>
        </div>
      </el-carousel-item>
    </div>
    </el-carousel>
    
        <!-- <div class="show_text">
          <el-image fit="contain" class="show_text-img" :src="require('../assets/title.png')"></el-image>
        </div> -->
      
    <div class="show_text">
    </div>
        <div style="width:100%;display:flex; justify-content: center;">
        <div class="show_main">   
          <el-row  type="flex" style="margin: 0; justify-content: center">
          <el-col :xs="22" :sm="22" :md="22" :lg="20" :xl="20">
        <el-row :gutter="10" type="flex" style="flex-wrap: wrap">
          <el-col
            :xs="12"
            :sm="12"
            :md="8"
            :lg="8"
            :xl="8"
            v-for="(item, index) in modalList"
            v-bind:key="index"
          >
            <el-card shadow="never" class="word-card"  :body-style="{ padding: '0px' }">
              <el-image
                class="card_image"
                :src="`${item.url}`"
                fit="contain"
                @click="gotoDetail(item.id)"
                lazy
              >
              <el-image slot="placeholder" :src="require('../assets/test.jpg')" v-loading="load"  class="image_item">
            
              </el-image>
              </el-image>
              <div
                class="card-info"
              >
                <div class="card-user" >
                  
                  <el-image fit="contain" @click.native="gotoUser(item.artist_id)" class="card-user-img" :src="`${item.avatar}`"></el-image>
                  <div  >{{ item.artist_name }}</div>
                </div>
                <div style="width:65%">
                  <div class="card-name"   >
                  {{item.name}}
                  </div>
                  
                  <div class="card-content" >
                    {{item.content}}
                  </div>
                  <div class="card-button" @click="gotoDetail(item.id)">
                    查看细节
                  </div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        </el-col>
        </el-row>
        </div> 
        </div>
  </div>
</template>

<script>
import {getIndex} from "@/api/api.js"
export default {
  data() {
    return {
      modalList: [],
      load:true,
      carousolList:[
        
      ],
      picrouter:'',
      height: window.innerWidth * 0.4 + "px",
      width:window.innerWidth
    };
  },
 async mounted() {
    if(window.innerWidth < 767){
      this.height = window.innerHeight * 0.4 +"px"
    }
    if(window.innerWidth * 0.4 > 600){
      this.height = '600px'
    }
    await getIndex().then(res=>{
      console.log(res)
      let data = res.data
      this.carousolList = data.banner
      for(let i = 0 ; i < this.carousolList.length; i++){
        if(this.carousolList[i].pic.indexOf('http') == -1){
          this.carousolList[i].pic = this.picrouter +this.carousolList[i].pic
        }
        if( this.carousolList[i].m_pic && this.carousolList[i].m_pic.indexOf('http') == -1){
          this.carousolList[i].m_pic = this.picrouter +this.carousolList[i].m_pic
        }
      }
      for(let i = 0 ; i < data.productIndex.length; i++){
        if(data.productIndex[i].url.indexOf('http') == -1){
          data.productIndex[i].url = this.picrouter +data.productIndex[i].url
        }
        if(data.productIndex[i].avatar.indexOf('http') == -1){
          data.productIndex[i].avatar = this.picrouter +data.productIndex[i].avatar
        }
      }
      this.modalList = data.productIndex
    })
    // this.getModel();
  },
  methods: {
    async getModel() {
      const res = await this.axios.get("/mock.json");
      this.modalList = res.data.data;
      console.log(this.modalList);
    },
    gotoDetail(id) {
      this.$router.push({ path: "/" + id });
    },
    gotoUser(id) {
      this.$router.push({ path: "/user/" + id });
    },
    start(e) {
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
    },
    move(e) {
      this.moveX = e.touches[0].clientX;
      this.moveY = e.touches[0].clientY;
      var nowtime = new Date().getTime();
      if (this.startTime == undefined || nowtime > this.startTime) {
        if (this.startX - this.moveX <= 0) { 
          this.prev();
          return false;
        } else {
          this.next();
          return false;
        }
      }
    },
    prev() {
      this.$refs.nop.prev();
      this.startTime = new Date().getTime() + 500;
    },
    next() {
      this.$refs.nop.next();
      this.startTime = new Date().getTime() + 500;
    },
  },
};
</script>

<style  scoped>
.home{
  background: url('../assets/bg.png') no-repeat;
}
.home_carousel {
  width: 100%;
  height: 100%;
  cursor: pointer;
  -webkit-user-drag: none;
  -moz-user-drag: none;
  -khtml-user-drag: none;
  -ms-user-drag: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}
.show_text {
  margin-top: 15px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  font-size: 40px;
  background: #fff;
}
.show_text-img{
  height: 100%;
}
.show_main{
  max-width: 1250px;
}
.card_image {
  width: 100%;
  height: 50vw;
  max-height: 386px;
  display: block;
  cursor: pointer;
}
.image-slot{
  width: 100%;
  height: 50vw;
  max-height: 386px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.image_item{
  width: 100%;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.work_name{
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.word-card{
  width: 100%;
  border: none;
  
}
.card-info{
  padding:15px 0px;
  display: flex;
}
.card-user{
  width:35%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.card-user-img{
  width: 85%;
  height: 110px;
}
.card-user >div:nth-child(2){
  font-size: 16px;
  margin-top: 20px;
  font-weight: bold;
}
.card-name{
  font-size: 24px;
  height: 31px;
  text-overflow:ellipsis;
  -webkit-line-clamp: 1;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.card-content{
  font-size: 14px;
  height: 80px;
  -webkit-line-clamp: 4;
  overflow: hidden;
  color: #a7a7a7;
  -webkit-box-orient: vertical;
  text-overflow:ellipsis;
  display:-webkit-box;
  line-height: 20px;
}
.card-button{
  background-color: #4a4a4a;
  height: 40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  margin:10px 0 60px 0;
  cursor: pointer;
}
@media screen and (max-width: 767px){
  .card-name{
    font-size: 16px;
    height: 16px;
    line-height: 16px;
  }
  .card-info{
    padding: 8px 0;
  }
  .card-info>div:nth-child(2)>div:nth-child(2){
    font-size: 12px !important;
  }
  .card-content{
    font-size: 12px;
    height: 45px;
  }
  .card-user-img{
    height: 75px;
  }
  .card-user >div:nth-child(2){
    font-size: 12px;
    margin-top: 15px;
    font-weight: bold;
  }
  .card-button{
    height: 20px;
    width: 100%;
    font-size: 8px;
    color: #fff;
    margin:10px 0 30px 0;
  }
}
</style>


